import { apiSlice } from "./api/apiSlice";

const telesaleleadSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTelesalesAssignments: builder.query({
            query: ({
                limit = 10,
                page = 1,
                status,
                startDate,
                endDate,
                phoneNumber,
                projectID,
                leadID,
                callStatus,
                clientName
            }) => {
                const params = new URLSearchParams();
                params.append('limit', limit);
                params.append('page', page);

                if (status) params.append('status', status);
                if (startDate) params.append('startDate', startDate);
                if (endDate) params.append('endDate', endDate);
                if (phoneNumber) params.append('phoneNumber', phoneNumber);
                if (projectID) params.append('projectID', projectID);
                if (leadID) params.append('leadID', leadID);
                if (callStatus) params.append('callStatus', callStatus);
                if (clientName) params.append('clientName', clientName);

                return `/telesales/assignments/telesales-assignments?${params.toString()}`;
            },
            invalidatesTags: ["Leads", "Telesale"],
        }),
        addFavouriteTelesaleslead: builder.mutation({
            query: (id) => ({
                url: `telesales/assignments/favourites/${id}`,
                method: "POST",
            }),
            invalidatesTags: ["Leads", "Telesale"],
        }),
        getFavouriteTelesalesAssignments: builder.query({
            query: ({
                limit = 10,
                page = 1,
            }) => ({
                url: `telesales/assignments/favourite-assignments?page=${page}&limit=${limit}`,
                method: "GET",
            }),
            providesTags: ["Telesale"],
        }),
        removeFavouriteTelesaleslead: builder.mutation({
            query: (id) => ({
                url: `telesales/assignments/favourites/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Leads", "Telesale"],
        }),
        getTelesalesManagedLeads: builder.query({
            query: ({
                classification,
                source,
                projectID,
                from,
                numTasks,
                taskType,
                taskSubType,
                nextTaskType,
                clientType,
                phoneNumber,
                startDate,
                endDate,
                lastContact,
                leadID,
                clientID,
                clientName,
                inactiveLeads,
                page = 1,
                limit = 10,
            }) => {
                const params = new URLSearchParams();
                params.append('page', page);
                params.append('limit', limit);

                if (classification) params.append('classification', classification);
                if (source) params.append('source', source);
                if (projectID) params.append('projectID', projectID);
                if (from) params.append('from', from);
                if (numTasks) params.append('numTasks', numTasks);
                if (taskType) params.append('taskType', taskType);
                if (taskSubType) params.append('taskSubType', taskSubType);
                if (nextTaskType) params.append('nextTaskType', nextTaskType);
                if (clientType) params.append('clientType', clientType);
                if (phoneNumber) params.append('phoneNumber', phoneNumber);
                if (startDate) params.append('startDate', startDate);
                if (endDate) params.append('endDate', endDate);
                if (lastContact) params.append('lastContact', lastContact);
                if (leadID) params.append('leadID', leadID);
                if (clientID) params.append('clientID', clientID);
                if (clientName) params.append('clientName', clientName);
                if (inactiveLeads) params.append('inactiveLeads', inactiveLeads);

                return `/telesales/tasks/telesales-leads-filter?${params.toString()}`;
            },
            transformResponse: (response) => response,
            providesTags: ["TelesaleLeads"],
        }),
        getTelesalesManagedLeadsLazy: builder.query({
            query: ({
                classification,
                source,
                projectID,
                from,
                numTasks,
                taskType,
                taskSubType,
                nextTaskType,
                clientType,
                phoneNumber,
                startDate,
                endDate,
                lastContact,
                leadID,
                clientID,
                clientName,
                inactiveLeads,
                page = 1,
                limit = 10,
            }) => {
                const params = new URLSearchParams();
                params.append('page', page);
                params.append('limit', limit);

                if (classification) params.append('classification', classification);
                if (source) params.append('source', source);
                if (projectID) params.append('projectID', projectID);
                if (from) params.append('from', from);
                if (numTasks) params.append('numTasks', numTasks);
                if (taskType) params.append('taskType', taskType);
                if (taskSubType) params.append('taskSubType', taskSubType);
                if (nextTaskType) params.append('nextTaskType', nextTaskType);
                if (clientType) params.append('clientType', clientType);
                if (phoneNumber) params.append('phoneNumber', phoneNumber);
                if (startDate) params.append('startDate', startDate);
                if (endDate) params.append('endDate', endDate);
                if (lastContact) params.append('lastContact', lastContact);
                if (leadID) params.append('leadID', leadID);
                if (clientID) params.append('clientID', clientID);
                if (clientName) params.append('clientName', clientName);
                if (inactiveLeads) params.append('inactiveLeads', inactiveLeads);

                return `/telesales/tasks/telesales-leads-filter?${params.toString()}`;
            },
            transformResponse: (response) => response,
        }),

    })
})

export const {
    useGetTelesalesAssignmentsQuery,
    useAddFavouriteTelesalesleadMutation,
    useGetFavouriteTelesalesAssignmentsQuery,
    useRemoveFavouriteTelesalesleadMutation,
    useGetTelesalesManagedLeadsQuery,
    useLazyGetTelesalesManagedLeadsQuery
} = telesaleleadSlice;